// LEVAMI storefront interface translations (FR / EN / DE).
// Scope: navigation, buttons, forms, cart/checkout and common system messages.
// Long-form editorial pages (Histoire, Artisanat, Partenariats...) remain French-only for now
// (see UntranslatedNotice) — full editorial translation is planned for a later phase.
// French is always the fallback source of truth if a key is missing in EN/DE.

export const TRANSLATIONS = {
  fr: {
    "nav.accueil": "Accueil",
    "nav.espace_pro": "Espace Pro",
    "nav.boutique": "Boutique",
    "nav.voir_toute_boutique": "Voir toute la boutique",
    "nav.histoire": "Notre histoire",
    "nav.artisanat": "Savoir-faire",
    "nav.lookbook": "Lookbook",
    "nav.journal": "Stories",
    "nav.ateliers": "Ateliers",
    "nav.partenariats": "Collaborations",
    "nav.contact": "Contact",
    "nav.search_aria": "Rechercher",
    "nav.search_title": "Rechercher un produit",
    "nav.search_label": "Rechercher un produit",
    "nav.search_placeholder": "Keffieh, robe, tatreez...",
    "nav.search_button": "Rechercher",
    "nav.cart_aria": "Ouvrir le panier",
    "nav.menu_aria": "Menu",
    "nav.menu_title": "Menu de navigation",
    "nav.language": "Langue",
    "nav.currency": "Devise",

    "shop.nouveautes": "Nouveautés",
    "shop.keffiehs": "Keffiehs",
    "shop.robes_abayas": "Robes & Abayas",
    "shop.pieces_brodees": "Pièces brodées",
    "shop.chales_ponchos": "Châles & Ponchos",
    "shop.sacs_accessoires": "Sacs & Accessoires",
    "shop.bijoux": "Bijoux",
    "shop.all": "Toute la boutique",
    "shop.color": "Couleur",
    "shop.size": "Taille",
    "shop.on_sale": "En promotion",
    "shop.is_new": "Nouveautés",
    "shop.show_more": "Voir plus",
    "shop.show_less": "Voir moins",
    "shop.clear_filters": "Effacer les filtres",
    "shop.sort_placeholder": "Trier par",
    "shop.sort_nouveautes": "Nouveautés",
    "shop.sort_prix_croissant": "Prix croissant",
    "shop.sort_prix_decroissant": "Prix décroissant",
    "shop.sort_mis_en_avant": "Mis en avant",
    "shop.filters": "Filtres",
    "shop.filters_title": "Filtres",
    "shop.search_placeholder": "Rechercher...",
    "shop.intro": "Des pièces à porter, des histoires à transmettre. Explorez les couleurs et les savoir-faire du Levant.",
    "shop.categories": "Parcourir les collections",
    "shop.show_results": "Voir les pièces",
    "shop.load_error": "La boutique n’a pas pu être chargée. Réessayez dans un instant.",
    "product.load_error": "Cette pièce n’a pas pu être chargée.",
    "product.choose_size": "Choisissez votre taille",
    "product.zoom_image": "Agrandir la photo",
    "product.shipping_summary": "Retrouvez les tarifs, délais et conditions de retour sur la page",
    "trust.returns_policy": "Conditions de retour",
    "trust.returns_days": "Retours sous {{days}} jours",
    "product.toggle_zoom": "Activer ou désactiver le zoom",
    "common.page_load_error": "Cette page n’a pas pu être chargée. Réessayez dans un instant.",
    "faq.search": "Rechercher une question…",
    "faq.no_answer": "Vous ne trouvez pas votre réponse ? Nous sommes là pour vous aider.",
    "contact.sent": "Votre message a bien été reçu. Merci de nous avoir contactés.",
    "shop.no_color": "Aucune couleur disponible.",
    "shop.no_size": "Aucune taille disponible.",
    "shop.empty_title": "Aucune pièce ne correspond à votre recherche",
    "shop.empty_text": "Essayez d'ajuster vos filtres ou explorez toute la boutique.",
    "shop.results_for": "Résultats pour « {{query}} »",
    "shop.piece_singular": "pièce",
    "shop.piece_plural": "pièces",
    "shop.pagination": "Pagination de la boutique",
    "shop.previous_page": "Précédent",
    "shop.next_page": "Suivant",
    "shop.page_of": "Page {{page}} sur {{pages}}",

    "footer.boutique": "Boutique",
    "footer.decouvrir": "Découvrir",
    "footer.aide": "Aide",
    "footer.livraison_retours": "Livraison & Retours",
    "footer.faq": "FAQ",
    "footer.cgv": "Conditions générales",
    "footer.confidentialite": "Confidentialité",
    "footer.cookies": "Cookies",
    "footer.mentions_legales": "Mentions légales",
    "footer.tagline": "Du Levant, pour le monde",
    "footer.description": "Vêtements, textiles et accessoires liés aux héritages palestinien et syrien.",
    "footer.newsletter_heading": "Rejoignez l'univers Levami",
    "footer.rights": "Tous droits réservés.",

    "cart.title": "Votre panier",
    "cart.empty": "Votre panier est vide.",
    "cart.discover": "Découvrir la boutique",
    "cart.remaining": "Plus que {{amount}} pour bénéficier de la livraison offerte.",
    "cart.free_shipping_included": "Livraison offerte incluse",
    "cart.subtotal": "Sous-total",
    "cart.discount": "Réduction",
    "cart.shipping": "Livraison",
    "cart.free": "Offerte",
    "cart.total": "Total",
    "cart.coupon_placeholder": "Code promo",
    "cart.apply": "Appliquer",
    "cart.view_and_pay": "Voir le panier et payer",
    "cart.remove_item": "Retirer l'article",
    "cart.applied_code": "Code {{code}} appliqué.",
    "cart.page_title": "Votre panier",
    "cart.page_empty_title": "Votre panier est vide",
    "cart.coordinates": "Vos coordonnées",
    "cart.full_name": "Nom complet",
    "cart.email": "Email",
    "cart.phone": "Téléphone",
    "cart.shipping_address": "Adresse de livraison",
    "cart.address": "Adresse",
    "cart.address_complement": "Complément (facultatif)",
    "cart.postal_code": "Code postal",
    "cart.city": "Ville",
    "cart.country": "Pays",
    "cart.summary": "Récapitulatif",
    "cart.pay_button": "Procéder au paiement",
    "cart.redirecting": "Redirection vers le paiement...",
    "cart.secure_payment": "Paiement sécurisé.",
    "cart.eur_charge_note": "Le paiement est traité en euros (EUR) — votre banque applique la conversion.",
    "cart.payment_unavailable": "Le paiement en ligne est momentanément indisponible. Contactez-nous pour finaliser votre commande.",
    "cart.missing_contact": "Merci de renseigner vos coordonnées.",
    "cart.missing_address": "Merci de renseigner votre adresse de livraison.",

    "toast.added_to_cart": "Ajouté au panier",
    "toast.view_cart": "Voir le panier",
    "trust.secure_payment": "Paiement sécurisé",
    "trust.returns": "Retours sous 14 jours",
    "trust.tracked_delivery": "Livraison suivie",
    "trust.craftsmanship": "Artisanat palestinien & syrien",
    "product.size_guide": "Guide des tailles",
    "product.quantity": "Quantité",
    "sizeguide.col_size": "Taille",
    "sizeguide.col_chest": "Tour de poitrine",
    "sizeguide.col_waist": "Tour de taille",
    "sizeguide.col_hips": "Tour de hanches",
    "sizeguide.col_length": "Longueur",
    "sizeguide.unit_note": "Mesures en cm, à plat.",
    "product.verified_purchase": "Achat vérifié",
    "product.link_copied": "Lien copié.",
    "tracking.title": "Suivre ma commande",
    "tracking.subtitle": "Entrez votre email et votre numéro de commande pour voir son statut.",
    "tracking.email_label": "Email",
    "tracking.order_label": "Numéro de commande",
    "tracking.submit": "Suivre ma commande",
    "tracking.searching": "Recherche...",
    "tracking.not_found": "Aucune commande trouvée avec cet email et ce numéro. Vérifiez vos informations.",
    "tracking.status_label": "Statut de la commande",
    "tracking.number_label": "Numéro de suivi",
    "tracking.carrier_label": "Transporteur",
    "tracking.items_label": "Articles",
    "tracking.total_label": "Total",
    "tracking.date_label": "Commande passée le",
    "tracking.help": "Une question sur votre commande ?",
    "tracking.contact_us": "Contactez-nous",
    "status.en_attente": "En attente",
    "status.payee": "Payée",
    "status.en_preparation": "En préparation",
    "status.expediee": "Expédiée",
    "status.livree": "Livrée",
    "status.annulee": "Annulée",
    "status.remboursee": "Remboursée",
    "lookbook.shop_the_look": "Acheter le look",
    "lookbook.pieces_in_photo": "Les pièces portées sur cette photo",
    "common.see": "Voir",
    "welcome.title": "{{discount}} sur votre première commande",
    "welcome.thanks_title": "Bienvenue chez LEVAMI",
    "welcome.text": "Inscrivez-vous à notre newsletter et recevez {{discount}} sur votre première commande. Histoires d'artisanat, nouveautés et offres — jamais de spam.",
    "welcome.email_placeholder": "Votre adresse email",
    "welcome.cta": "Recevoir mon code {{discount}}",
    "welcome.no_thanks": "Non merci, je continue sans réduction",
    "welcome.consent_note": "En vous inscrivant, vous acceptez de recevoir nos emails. Désinscription en un clic.",
    "welcome.code_text": "Merci ! Voici votre code à utiliser au panier :",
    "welcome.start_shopping": "Découvrir la boutique",
    "welcome.error": "L'inscription a échoué. Veuillez réessayer.",
    "instagram.title": "Suivez l'atelier au quotidien",

    "product.add_to_cart": "Ajouter au panier",
    "product.unavailable": "Indisponible",
    "product.out_of_stock": "Épuisé",
    "product.in_stock": "En stock",
    "product.low_stock": "Plus que {{count}} en stock",
    "product.color": "Couleur",
    "product.size": "Taille",
    "product.description": "Description",
    "product.story": "L'histoire de la pièce",
    "product.material_origin": "Matière & origine",
    "product.care": "Entretien",
    "product.shipping_returns": "Livraison & retours",
    "product.shipping_returns_text": "Livraison offerte dès 50€ d'achat. Retours possibles sous 14 jours. Consultez notre page",
    "product.shipping_returns_link": "Livraison & Retours",
    "product.related": "Vous aimerez aussi",
    "product.reviews": "Avis clients",
    "product.leave_review": "Laisser un avis",
    "product.no_reviews": "Aucun avis pour le moment. Soyez le premier à partager votre expérience.",
    "product.share": "Partager :",
    "product.breadcrumb_home": "Accueil",
    "product.breadcrumb_shop": "Boutique",
    "product.not_found": "Produit introuvable",
    "product.back_to_shop": "Retour à la boutique",
    "product.not_translated": "Cette fiche produit n'est pas encore entièrement traduite. Certaines informations sont affichées en français.",
    "product.review_title_placeholder": "Titre de votre avis",
    "product.review_text_placeholder": "Votre avis",
    "product.review_firstname_placeholder": "Votre prénom",
    "product.review_email_placeholder": "Votre email",
    "product.review_order_placeholder": "Numéro de commande (facultatif, pour achat vérifié)",
    "product.review_submit": "Envoyer mon avis",
    "product.review_submitting": "Envoi...",

    "common.loading": "Chargement...",
    "common.error": "Une erreur est survenue. Veuillez réessayer.",
    "announcement.default": "Livraison offerte dès 50 € · Retours sous 14 jours",
    "faq.title": "Questions fréquentes",
    "journal.eyebrow": "Stories",
    "journal.title": "Récits & coulisses",
    "journal.empty": "Aucun article publié pour le moment.",
    "journal.empty_cta": "Découvrir la boutique",
    "journal.all_categories": "Tous les articles",
    "wishlist.title": "Mes favoris",
    "wishlist.eyebrow": "Favoris",
    "wishlist.subtitle": "Vos pièces préférées, enregistrées sur cet appareil.",
    "wishlist.empty": "Votre liste de favoris est vide pour le moment.",
    "wishlist.unavailable": "Les articles enregistrés ne sont plus disponibles.",
    "wishlist.browse": "Découvrir la boutique",
    "wishlist.add_aria": "Ajouter aux favoris",
    "wishlist.remove_aria": "Retirer des favoris",
    "wishlist.nav_aria": "Voir mes favoris",
    "wishlist.choose_options": "Choisir les options",
    "wishlist.sold_out": "Épuisé pour le moment — revenez bientôt",
    "b2b.back_to_shop": "Retour à la boutique",
    "b2b.portal_title": "Espace professionnel",
    "b2b.portal_subtitle": "Tarifs grossistes, commandes en gros et devis pour les revendeurs.",
    "b2b.login_tab": "Connexion",
    "b2b.register_tab": "Demander un accès",
    "b2b.qty_tiers_title": "Remises par quantité",
    "b2b.qty_tier_line": "Dès {{qty}} pièces : -{{percent}}% supplémentaires",
    "b2b.subtotal_label": "Sous-total",
    "b2b.qty_discount_label": "Remise quantité (-{{percent}}%)",
    "b2b.qty_tier_hint": "Encore {{missing}} pièce(s) pour bénéficier de -{{percent}}% supplémentaires.",
    "b2b.forgot_link": "Mot de passe oublié ?",
    "b2b.forgot_title": "Mot de passe oublié",
    "b2b.forgot_intro": "Indiquez l'adresse e-mail de votre compte professionnel : un lien de réinitialisation (valable 60 minutes) vous sera envoyé.",
    "b2b.forgot_send": "Envoyer le lien",
    "b2b.forgot_sent_title": "E-mail envoyé",
    "b2b.forgot_sent_body": "Si un compte existe pour cette adresse, un e-mail de réinitialisation vient d'être envoyé. Pensez à vérifier vos spams.",
    "b2b.back_to_login": "Retour à la connexion",
    "b2b.reset_title": "Nouveau mot de passe",
    "b2b.reset_subtitle": "Choisissez un nouveau mot de passe pour votre compte professionnel.",
    "b2b.reset_invalid_link": "Lien invalide ou expiré.",
    "b2b.new_password": "Nouveau mot de passe",
    "b2b.confirm_password": "Confirmer le mot de passe",
    "b2b.reset_submit": "Réinitialiser le mot de passe",
    "b2b.reset_success": "Mot de passe réinitialisé — connectez-vous.",
    "b2b.passwords_mismatch": "Les deux mots de passe ne correspondent pas.",
    "b2b.password": "Mot de passe",
    "b2b.password_hint": "8 caractères min., lettres + chiffres",
    "b2b.login_button": "Se connecter",
    "b2b.company": "Société / boutique",
    "b2b.contact_name": "Nom du contact",
    "b2b.phone": "Téléphone",
    "b2b.register_message": "Présentez votre activité (facultatif)",
    "b2b.register_button": "Envoyer ma demande",
    "b2b.register_note": "Votre demande sera examinée par notre équipe. Vous recevrez un email dès l'activation.",
    "b2b.register_success_title": "Demande envoyée !",
    "b2b.register_success_body": "Notre équipe examine votre demande. Vous recevrez un email dès que votre accès sera activé.",
    "b2b.nav_catalog": "Catalogue",
    "b2b.nav_boutique": "Boutique",
    "b2b.nav_orders": "Mes commandes",
    "b2b.professional_price": "Tarif professionnel",
    "b2b.price_unavailable": "Tarif professionnel indisponible",
    "b2b.product_minimum": "Commande minimale : {{quantity}} pièces",
    "b2b.add_to_order": "Ajouter à ma commande",
    "b2b.added_to_order_cart": "Ajouté à votre commande professionnelle",
    "b2b.view_order_cart": "Voir la commande",
    "b2b.local_demo_title": "Démonstration B2B locale",
    "b2b.local_demo_email": "Email",
    "b2b.local_demo_password": "Mot de passe",
    "b2b.local_demo_safety": "Compte et produits fictifs. Les commandes, devis et paiements réels sont désactivés.",
    "b2b.local_demo_products": "Démonstration locale : les produits et tarifs affichés sont fictifs.",
    "b2b.logout": "Se déconnecter",
    "b2b.footer_note": "Portail réservé aux professionnels — paiement sur facture",
    "b2b.catalog_title": "Catalogue grossiste",
    "b2b.catalog_subtitle": "Vos tarifs professionnels",
    "b2b.search_products": "Rechercher un produit ou une référence",
    "b2b.product_count": "{{count}} produit(s)",
    "b2b.view_catalog": "Catalogue complet",
    "b2b.view_order": "Ma commande",
    "b2b.add_more_products": "Ajouter d'autres articles",
    "b2b.price_retail_unit": "Prix détail / unité",
    "b2b.price_pro_unit": "Prix pro / unité",
    "b2b.price_pro_total": "Total pro",
    "b2b.retail_total": "Total au prix détail",
    "b2b.increase_quantity": "Augmenter la quantité de",
    "b2b.decrease_quantity": "Diminuer la quantité de",
    "b2b.catalog_error": "Le catalogue n'a pas pu être chargé.",
    "b2b.no_products_match": "Aucun produit ne correspond à cette recherche.",
    "b2b.retry": "Réessayer",
    "b2b.order_status.soumise": "Soumise",
    "b2b.order_status.confirmee": "Confirmée",
    "b2b.order_status.facturee": "Facturée",
    "b2b.order_status.expediee": "Expédiée",
    "b2b.order_status.annulee": "Annulée",
    "b2b.quote_status.nouveau": "Nouveau",
    "b2b.quote_status.en_cours": "En cours",
    "b2b.quote_status.repondu": "Répondu",
    "b2b.quote_status.cloture": "Clôturé",
    "b2b.prices_eur_note": "Prix en euros · TVA non appliquée",
    "cart.no_vat": "TVA non appliquée",
    "cart.continue_shopping": "Continuer mes achats",
    "b2b.col_product": "Produit",
    "b2b.col_retail": "Prix détail",
    "b2b.col_wholesale": "Prix pro",
    "b2b.col_min": "Qté min",
    "b2b.col_qty": "Quantité",
    "b2b.col_date": "Date",
    "b2b.col_status": "Statut",
    "b2b.stock": "Stock :",
    "b2b.cart_title": "Votre commande",
    "b2b.cart_empty": "Ajoutez des quantités depuis le catalogue.",
    "b2b.remove": "Retirer",
    "b2b.min_warning": "Quantité minimale non atteinte :",
    "b2b.total_estimate": "Total estimé",
    "b2b.place_order": "Passer commande",
    "b2b.request_quote": "Demander un devis",
    "b2b.invoice_note": "Commande sur facture — aucun paiement en ligne. Nous vous confirmons la commande sous 48 h.",
    "b2b.confirm_order_title": "Confirmer la commande",
    "b2b.confirm_quote_title": "Demander un devis",
    "b2b.items_label": "article(s)",
    "b2b.order_note_placeholder": "Note pour notre équipe (livraison, délais...)",
    "b2b.quote_note_placeholder": "Votre message (quantités souhaitées, personnalisation...)",
    "b2b.confirm_order_button": "Confirmer la commande",
    "b2b.confirm_quote_button": "Envoyer la demande de devis",
    "b2b.order_submitted": "Commande envoyée",
    "b2b.quote_submitted": "Demande de devis envoyée. Nous revenons vers vous rapidement.",
    "b2b.history_title": "Mes commandes & devis",
    "b2b.quotes_label": "Devis",
    "b2b.no_orders": "Aucune commande pour le moment.",
    "b2b.no_quotes": "Aucune demande de devis pour le moment.",
    "b2b.estimate_label": "Estimation",
    "ateliers.eyebrow": "Savoir-faire",
    "ateliers.title": "Ateliers & artisans",
    "ateliers.empty": "Aucune fiche publiée pour le moment.",
    "ateliers.empty_cta": "Découvrir le savoir-faire",

    "home.seo_title": "LEVAMI | Keffiehs, Tatreez et mode contemporaine du Levant",
    "home.seo_description": "LEVAMI est une maison de mode et de textile culturel enracinée dans les héritages palestinien, syrien et levantin. Keffiehs, robes, pièces brodées, châles et bijoux.",
    "home.hero_eyebrow": "Nouvelle collection",
    "home.hero_title_line1": "Portez",
    "home.hero_title_line2": "une histoire",
    "home.hero_subtitle": "Des keffiehs, des pièces brodées et des vêtements contemporains liés aux héritages palestinien et syrien.",
    "home.hero_cta_boutique": "Découvrir la boutique",
    "home.hero_cta_histoire": "Découvrir notre histoire",
    "home.collections_title": "Les collections",
    "home.featured_title": "Pièces choisies",
    "home.intro_eyebrow": "La maison",
    "home.intro_title": "Du Levant, pour le monde",
    "home.intro_p1": "LEVAMI est une marque de vêtements et de textiles née entre la Palestine, la Syrie et la France.",
    "home.intro_p2": "Nous développons et sélectionnons des keffiehs, des pièces brodées, des robes, des châles et des accessoires conçus pour être portés aujourd'hui.",
    "home.founder_title": "Une histoire vécue",
    "home.founder_quote": "Je voulais créer une marque ancrée dans une histoire réelle, pas seulement dans une esthétique.",
    "home.founder_p1": "Iwan est franco-syrien et d'origine palestinienne. Sa famille vient de Tibériade, en Palestine. Il est né et a grandi en Syrie, au contact des communautés palestiniennes de Damas et de sa campagne.",
    "home.founder_p2": "Après plus de dix ans dans le secteur humanitaire et plus de onze années loin de la Syrie, il y est retourné. Il a retrouvé des proches, des familles et des ateliers dont les savoir-faire avaient traversé les années de guerre et de crise. Cette expérience a donné naissance à LEVAMI.",
    "home.founder_cta": "Lire notre histoire",
    "home.craft_title": "Le geste derrière la pièce",
    "home.craft_p1": "Depuis des générations, des personnes brodent, tissent, coupent et assemblent les textiles du Levant.",
    "home.craft_p2": "LEVAMI travaille avec des proches, des artisans et des ateliers pour donner une place actuelle à ces gestes.",
    "home.craft_cta": "Découvrir le savoir-faire",
    "home.lookbook_title": "Porté au quotidien",
    "home.lookbook_subtitle": "Des pièces portées simplement, seules ou superposées.",
    "home.lookbook_cta": "Voir le lookbook",
    "home.principles_title": "Comment nous travaillons",
    "home.principle1_title": "Relations directes",
    "home.principle1_text": "Des liens construits avec des familles, des proches et des ateliers, plutôt qu'un réseau anonyme.",
    "home.principle2_title": "Séries à taille humaine",
    "home.principle2_text": "Des collections avancent selon les capacités des ateliers et la qualité recherchée.",
    "home.principle3_title": "Transparence produit",
    "home.principle3_text": "Chaque fiche indique le rôle de LEVAMI, le lieu de production et les matières lorsque l'information est disponible.",
    "home.newsletter_title": "Recevoir les nouvelles de LEVAMI",
    "home.newsletter_subtitle": "Nouvelles collections, histoires de pièces, événements et éditions limitées.",
    "home.alt_hero": "Groupe de quatre personnes portant des keffiehs et des pièces brodées Levami dans un jardin.",
    "home.alt_founder": "Portrait d'Iwan, fondateur de LEVAMI, portant une pièce brodée.",
    "home.alt_craft": "Femme portant un keffieh et une création brodée Levami.",
    "home.alt_lookbook_group": "Groupe portant des créations Levami dans un jardin végétal.",
    "home.alt_lookbook_solo": "Femme portant un haut blanc brodé et une longue jupe noire brodée.",

    "contact.seo_title": "Contact | LEVAMI",
    "contact.seo_description": "Contactez l'équipe LEVAMI par email, WhatsApp ou via notre formulaire.",
    "contact.title": "Contact",
    "contact.whatsapp_label": "WhatsApp :",
    "contact.firstname_placeholder": "Prénom",
    "contact.lastname_placeholder": "Nom",
    "contact.email_placeholder": "Email",
    "contact.order_placeholder": "Numéro de commande (facultatif)",
    "contact.subject_placeholder": "Sujet",
    "contact.subject_order": "Commande",
    "contact.subject_product": "Produit",
    "contact.subject_partnership": "Partenariat",
    "contact.subject_press": "Presse",
    "contact.subject_event": "Événement",
    "contact.subject_other": "Autre",
    "contact.message_placeholder": "Votre message",
    "contact.consent_prefix": "J'accepte que mes données soient utilisées pour traiter ma demande, conformément à la",
    "contact.consent_link": "politique de confidentialité",
    "contact.consent_required_error": "Merci d'accepter notre politique de confidentialité.",
    "contact.submit": "Envoyer le message",
    "contact.submitting": "Envoi...",

    "lookbook.seo_title": "Lookbook LEVAMI | Porté au quotidien",
    "lookbook.seo_description": "Le lookbook LEVAMI présente les vêtements dans la vie réelle.",
    "lookbook.title": "Porté au quotidien",
    "lookbook.subtitle": "Des pièces portées simplement, seules ou superposées. Le lookbook montre les coupes, les détails et différentes façons de les associer.",
    "lookbook.filter_all": "Tout",
    "lookbook.empty": "Aucune image dans cette catégorie pour le moment.",

    "livraison.seo_title": "Livraison & Retours — LEVAMI",
    "livraison.seo_description": "Délais, tarifs de livraison et conditions de retour LEVAMI.",
    "livraison.title": "Livraison & Retours",
    "livraison.free_shipping_banner": "Livraison offerte dès {{amount}} €",
    "livraison.zones_title": "Zones de livraison",
    "livraison.zone_france": "France",
    "livraison.zone_eu": "Union européenne",
    "livraison.zone_europe_non_eu": "Europe hors UE",
    "livraison.zone_international": "International",
    "livraison.returns_title": "Retours",
    "livraison.returns_text": "Retours possibles sous {{days}} jours selon les conditions applicables.",
    "livraison.return_address_todo": "L’adresse de retour n’est pas encore renseignée. Contactez-nous pour obtenir les instructions avant de renvoyer un article.",
    "livraison.return_contact_link": "Nous contacter",

    "notfound.seo_title": "Page introuvable — LEVAMI",
    "notfound.seo_description": "Cette page n'existe pas.",
    "notfound.title": "Cette page n'existe pas",
    "notfound.text": "La page que vous recherchez a peut-être été déplacée ou n'existe plus.",
    "notfound.cta": "Retour à l'accueil",

    "checkout_cancel.seo_title": "Paiement annulé — LEVAMI",
    "checkout_cancel.seo_description": "Votre paiement a été annulé.",
    "checkout_cancel.title": "Paiement annulé",
    "checkout_cancel.text": "Votre paiement n'a pas été finalisé. Votre panier est conservé, vous pouvez réessayer à tout moment.",
    "checkout_cancel.cta": "Retour au panier",

    "journal_detail.not_found": "Article introuvable",
    "journal_detail.back": "Retour aux stories",

    "atelier_detail.not_found": "Fiche introuvable",
    "atelier_detail.back": "Retour aux ateliers",
    "atelier_detail.craft_fallback": "Savoir-faire",

    "cookie_consent.title": "Vos préférences de confidentialité",
    "cookie_consent.text": "Nous utilisons des cookies essentiels au fonctionnement du site. Avec votre accord, nous pouvons également utiliser des cookies de mesure d'audience et marketing. Consultez notre",
    "cookie_consent.policy_link": "politique de cookies",
    "cookie_consent.essential": "Cookies essentiels",
    "cookie_consent.analytics": "Mesure d'audience (Analytics)",
    "cookie_consent.marketing": "Marketing",
    "cookie_consent.accept_all": "Tout accepter",
    "cookie_consent.reject_all": "Tout refuser",
    "cookie_consent.customize": "Personnaliser",
    "cookie_consent.save_preferences": "Enregistrer mes choix",

    "newsletter.consent_error": "Merci d'accepter de recevoir nos actualités pour vous inscrire.",
    "newsletter.email_placeholder": "Votre adresse email",
    "newsletter.submit": "S'inscrire",
    "newsletter.submitting": "Inscription...",
    "newsletter.consent_prefix": "J'accepte de recevoir les actualités de LEVAMI et j'ai lu la",
    "newsletter.consent_link": "politique de confidentialité",

    "checkout_success.seo_title": "Commande confirmée — LEVAMI",
    "checkout_success.seo_description": "Votre commande LEVAMI a été confirmée.",
    "checkout_success.verifying": "Vérification du paiement en cours...",
    "checkout_success.thank_you": "Merci pour votre commande",
    "checkout_success.payment_confirmed": "Votre paiement de {{amount}} a été confirmé.",
    "checkout_success.order_number": "Numéro de commande :",
    "checkout_success.email_note": "Un email de confirmation vous sera envoyé (si un fournisseur d'emails est configuré).",
    "checkout_success.continue_shopping": "Continuer mes achats",
    "checkout_success.pending_title": "Paiement en cours de traitement",
    "checkout_success.pending_text": "Nous vérifions encore votre paiement. Vous recevrez une confirmation par email dès qu'il sera validé.",
    "checkout_success.back_home": "Retour à l'accueil",
    "checkout_success.error_title": "Impossible de confirmer le paiement",
    "checkout_success.error_text": "La session de paiement a expiré ou une erreur est survenue. Veuillez réessayer.",
    "checkout_success.back_cart": "Retour au panier",
  },

  en: {
    "nav.accueil": "Home",
    "nav.espace_pro": "Trade Portal",
    "nav.boutique": "Shop",
    "nav.voir_toute_boutique": "View the entire shop",
    "nav.histoire": "Our story",
    "nav.artisanat": "Craftsmanship",
    "nav.lookbook": "Lookbook",
    "nav.journal": "Stories",
    "nav.ateliers": "Workshops",
    "nav.partenariats": "Collaborations",
    "nav.contact": "Contact",
    "nav.search_aria": "Search",
    "nav.search_title": "Search a product",
    "nav.search_label": "Search a product",
    "nav.search_placeholder": "Keffieh, dress, tatreez...",
    "nav.search_button": "Search",
    "nav.cart_aria": "Open cart",
    "nav.menu_aria": "Menu",
    "nav.menu_title": "Navigation menu",
    "nav.language": "Language",
    "nav.currency": "Currency",

    "shop.nouveautes": "New arrivals",
    "shop.keffiehs": "Keffiehs",
    "shop.robes_abayas": "Dresses & Abayas",
    "shop.pieces_brodees": "Embroidered pieces",
    "shop.chales_ponchos": "Shawls & Ponchos",
    "shop.sacs_accessoires": "Bags & Accessories",
    "shop.bijoux": "Jewellery",
    "shop.all": "Entire shop",
    "shop.color": "Colour",
    "shop.size": "Size",
    "shop.on_sale": "On sale",
    "shop.is_new": "New arrivals",
    "shop.show_more": "Show more",
    "shop.show_less": "Show less",
    "shop.clear_filters": "Clear filters",
    "shop.sort_placeholder": "Sort by",
    "shop.sort_nouveautes": "New arrivals",
    "shop.sort_prix_croissant": "Price: low to high",
    "shop.sort_prix_decroissant": "Price: high to low",
    "shop.sort_mis_en_avant": "Featured",
    "shop.filters": "Filters",
    "shop.filters_title": "Filters",
    "shop.search_placeholder": "Search...",
    "shop.intro": "Pieces to wear, stories to share. Explore the colours and craftsmanship of the Levant.",
    "shop.categories": "Browse collections",
    "shop.show_results": "View pieces",
    "shop.load_error": "The shop could not be loaded. Please try again in a moment.",
    "product.load_error": "This piece could not be loaded.",
    "product.choose_size": "Choose your size",
    "product.zoom_image": "Enlarge photo",
    "product.shipping_summary": "Find delivery costs, times and return conditions on the",
    "trust.returns_policy": "Return conditions",
    "trust.returns_days": "Returns within {{days}} days",
    "product.toggle_zoom": "Toggle zoom",
    "common.page_load_error": "This page could not be loaded. Please try again in a moment.",
    "faq.search": "Search questions…",
    "faq.no_answer": "Can’t find your answer? We’re here to help.",
    "contact.sent": "Your message has been received. Thank you for contacting us.",
    "shop.no_color": "No colour available.",
    "shop.no_size": "No size available.",
    "shop.empty_title": "No piece matches your search",
    "shop.empty_text": "Try adjusting your filters or browse the entire shop.",
    "shop.results_for": "Results for “{{query}}”",
    "shop.piece_singular": "item",
    "shop.piece_plural": "items",
    "shop.pagination": "Shop pagination",
    "shop.previous_page": "Previous",
    "shop.next_page": "Next",
    "shop.page_of": "Page {{page}} of {{pages}}",

    "footer.boutique": "Shop",
    "footer.decouvrir": "Discover",
    "footer.aide": "Help",
    "footer.livraison_retours": "Shipping & Returns",
    "footer.faq": "FAQ",
    "footer.cgv": "Terms & Conditions",
    "footer.confidentialite": "Privacy",
    "footer.cookies": "Cookies",
    "footer.mentions_legales": "Legal notice",
    "footer.tagline": "From the Levant, for the world",
    "footer.description": "Clothing, textiles and accessories rooted in Palestinian and Syrian heritage.",
    "footer.newsletter_heading": "Join the Levami world",
    "footer.rights": "All rights reserved.",

    "cart.title": "Your cart",
    "cart.empty": "Your cart is empty.",
    "cart.discover": "Discover the shop",
    "cart.remaining": "Only {{amount}} away from free shipping.",
    "cart.free_shipping_included": "Free shipping included",
    "cart.subtotal": "Subtotal",
    "cart.discount": "Discount",
    "cart.shipping": "Shipping",
    "cart.free": "Free",
    "cart.total": "Total",
    "cart.coupon_placeholder": "Promo code",
    "cart.apply": "Apply",
    "cart.view_and_pay": "View cart & pay",
    "cart.remove_item": "Remove item",
    "cart.applied_code": "Code {{code}} applied.",
    "cart.page_title": "Your cart",
    "cart.page_empty_title": "Your cart is empty",
    "cart.coordinates": "Your details",
    "cart.full_name": "Full name",
    "cart.email": "Email",
    "cart.phone": "Phone",
    "cart.shipping_address": "Shipping address",
    "cart.address": "Address",
    "cart.address_complement": "Additional info (optional)",
    "cart.postal_code": "Postal code",
    "cart.city": "City",
    "cart.country": "Country",
    "cart.summary": "Summary",
    "cart.pay_button": "Proceed to payment",
    "cart.redirecting": "Redirecting to payment...",
    "cart.secure_payment": "Secure payment.",
    "cart.eur_charge_note": "Payment is processed in euros (EUR) — your bank applies the conversion.",
    "cart.payment_unavailable": "Online payment is temporarily unavailable. Please contact us to complete your order.",
    "cart.missing_contact": "Please fill in your contact details.",
    "cart.missing_address": "Please fill in your shipping address.",

    "toast.added_to_cart": "Added to cart",
    "toast.view_cart": "View cart",
    "trust.secure_payment": "Secure payment",
    "trust.returns": "14-day returns",
    "trust.tracked_delivery": "Tracked delivery",
    "trust.craftsmanship": "Palestinian & Syrian craftsmanship",
    "product.size_guide": "Size guide",
    "product.quantity": "Quantity",
    "sizeguide.col_size": "Size",
    "sizeguide.col_chest": "Chest",
    "sizeguide.col_waist": "Waist",
    "sizeguide.col_hips": "Hips",
    "sizeguide.col_length": "Length",
    "sizeguide.unit_note": "Measurements in cm, taken flat.",
    "product.verified_purchase": "Verified purchase",
    "product.link_copied": "Link copied.",
    "tracking.title": "Track my order",
    "tracking.subtitle": "Enter your email and order number to see its status.",
    "tracking.email_label": "Email",
    "tracking.order_label": "Order number",
    "tracking.submit": "Track my order",
    "tracking.searching": "Searching...",
    "tracking.not_found": "No order found with this email and number. Please check your details.",
    "tracking.status_label": "Order status",
    "tracking.number_label": "Tracking number",
    "tracking.carrier_label": "Carrier",
    "tracking.items_label": "Items",
    "tracking.total_label": "Total",
    "tracking.date_label": "Order placed on",
    "tracking.help": "A question about your order?",
    "tracking.contact_us": "Contact us",
    "status.en_attente": "Pending",
    "status.payee": "Paid",
    "status.en_preparation": "Preparing",
    "status.expediee": "Shipped",
    "status.livree": "Delivered",
    "status.annulee": "Cancelled",
    "status.remboursee": "Refunded",
    "lookbook.shop_the_look": "Shop the look",
    "lookbook.pieces_in_photo": "The pieces worn in this photo",
    "common.see": "View",
    "welcome.title": "{{discount}} off your first order",
    "welcome.thanks_title": "Welcome to LEVAMI",
    "welcome.text": "Join our newsletter and receive {{discount}} off your first order. Craftsmanship stories, new arrivals and offers — never spam.",
    "welcome.email_placeholder": "Your email address",
    "welcome.cta": "Get my {{discount}} code",
    "welcome.no_thanks": "No thanks, I'll continue without a discount",
    "welcome.consent_note": "By signing up you agree to receive our emails. Unsubscribe in one click.",
    "welcome.code_text": "Thank you! Here is your code to use in the cart:",
    "welcome.start_shopping": "Start shopping",
    "welcome.error": "Signup failed. Please try again.",
    "instagram.title": "Follow the atelier day to day",

    "product.add_to_cart": "Add to cart",
    "product.unavailable": "Unavailable",
    "product.out_of_stock": "Out of stock",
    "product.in_stock": "In stock",
    "product.low_stock": "Only {{count}} left in stock",
    "product.color": "Colour",
    "product.size": "Size",
    "product.description": "Description",
    "product.story": "The story behind the piece",
    "product.material_origin": "Material & origin",
    "product.care": "Care",
    "product.shipping_returns": "Shipping & returns",
    "product.shipping_returns_text": "Free shipping from €50 of purchase. Returns possible within 14 days. See our",
    "product.shipping_returns_link": "Shipping & Returns",
    "product.related": "You may also like",
    "product.reviews": "Customer reviews",
    "product.leave_review": "Leave a review",
    "product.no_reviews": "No reviews yet. Be the first to share your experience.",
    "product.share": "Share:",
    "product.breadcrumb_home": "Home",
    "product.breadcrumb_shop": "Shop",
    "product.not_found": "Product not found",
    "product.back_to_shop": "Back to shop",
    "product.not_translated": "This product page is not fully translated yet. Some information is shown in French.",
    "product.review_title_placeholder": "Title of your review",
    "product.review_text_placeholder": "Your review",
    "product.review_firstname_placeholder": "Your first name",
    "product.review_email_placeholder": "Your email",
    "product.review_order_placeholder": "Order number (optional, for verified purchase)",
    "product.review_submit": "Send my review",
    "product.review_submitting": "Sending...",

    "common.loading": "Loading...",
    "common.error": "Something went wrong. Please try again.",
    "announcement.default": "Free shipping from €50 · Returns within 14 days",
    "faq.title": "Frequently Asked Questions",
    "journal.eyebrow": "Stories",
    "journal.title": "Stories & behind the scenes",
    "journal.empty": "No articles published yet.",
    "journal.empty_cta": "Explore the shop",
    "journal.all_categories": "All articles",
    "wishlist.title": "My wishlist",
    "wishlist.eyebrow": "Wishlist",
    "wishlist.subtitle": "Your favourite pieces, saved on this device.",
    "wishlist.empty": "Your wishlist is empty for now.",
    "wishlist.unavailable": "The saved items are no longer available.",
    "wishlist.browse": "Browse the shop",
    "wishlist.add_aria": "Add to wishlist",
    "wishlist.remove_aria": "Remove from wishlist",
    "wishlist.nav_aria": "View my wishlist",
    "wishlist.choose_options": "Choose options",
    "wishlist.sold_out": "Sold out for now — check back soon",
    "b2b.back_to_shop": "Back to the shop",
    "b2b.portal_title": "Trade portal",
    "b2b.portal_subtitle": "Wholesale pricing, bulk orders and quotes for retailers.",
    "b2b.login_tab": "Sign in",
    "b2b.register_tab": "Request access",
    "b2b.qty_tiers_title": "Volume discounts",
    "b2b.qty_tier_line": "From {{qty}} pieces: extra -{{percent}}%",
    "b2b.subtotal_label": "Subtotal",
    "b2b.qty_discount_label": "Volume discount (-{{percent}}%)",
    "b2b.qty_tier_hint": "Add {{missing}} more piece(s) to unlock an extra -{{percent}}%.",
    "b2b.forgot_link": "Forgot password?",
    "b2b.forgot_title": "Forgot password",
    "b2b.forgot_intro": "Enter your trade account email: a reset link (valid for 60 minutes) will be sent to you.",
    "b2b.forgot_send": "Send reset link",
    "b2b.forgot_sent_title": "Email sent",
    "b2b.forgot_sent_body": "If an account exists for this address, a reset email has just been sent. Remember to check your spam folder.",
    "b2b.back_to_login": "Back to sign in",
    "b2b.reset_title": "New password",
    "b2b.reset_subtitle": "Choose a new password for your trade account.",
    "b2b.reset_invalid_link": "Invalid or expired link.",
    "b2b.new_password": "New password",
    "b2b.confirm_password": "Confirm password",
    "b2b.reset_submit": "Reset password",
    "b2b.reset_success": "Password reset — please sign in.",
    "b2b.passwords_mismatch": "The two passwords do not match.",
    "b2b.password": "Password",
    "b2b.password_hint": "Min. 8 characters, letters + digits",
    "b2b.login_button": "Sign in",
    "b2b.company": "Company / boutique",
    "b2b.contact_name": "Contact name",
    "b2b.phone": "Phone",
    "b2b.register_message": "Tell us about your business (optional)",
    "b2b.register_button": "Send my request",
    "b2b.register_note": "Our team will review your request. You will receive an email once your access is activated.",
    "b2b.register_success_title": "Request sent!",
    "b2b.register_success_body": "Our team is reviewing your request. You will receive an email as soon as your access is activated.",
    "b2b.nav_catalog": "Catalogue",
    "b2b.nav_boutique": "Boutique",
    "b2b.nav_orders": "My orders",
    "b2b.professional_price": "Trade price",
    "b2b.price_unavailable": "Trade price unavailable",
    "b2b.product_minimum": "Minimum order: {{quantity}} pieces",
    "b2b.add_to_order": "Add to my order",
    "b2b.added_to_order_cart": "Added to your trade order",
    "b2b.view_order_cart": "View order",
    "b2b.local_demo_title": "Local B2B demo",
    "b2b.local_demo_email": "Email",
    "b2b.local_demo_password": "Password",
    "b2b.local_demo_safety": "Fictional account and products. Real orders, quotes, and payments are disabled.",
    "b2b.local_demo_products": "Local demo: the products and prices shown are fictional.",
    "b2b.logout": "Sign out",
    "b2b.footer_note": "Trade-only portal — payment on invoice",
    "b2b.catalog_title": "Wholesale catalogue",
    "b2b.catalog_subtitle": "Your trade prices",
    "b2b.search_products": "Search products or SKU",
    "b2b.product_count": "{{count}} product(s)",
    "b2b.view_catalog": "Full catalogue",
    "b2b.view_order": "My order",
    "b2b.add_more_products": "Add more products",
    "b2b.price_retail_unit": "Retail price / unit",
    "b2b.price_pro_unit": "Trade price / unit",
    "b2b.price_pro_total": "Trade total",
    "b2b.retail_total": "Retail-price total",
    "b2b.increase_quantity": "Increase quantity for",
    "b2b.decrease_quantity": "Decrease quantity for",
    "b2b.catalog_error": "The catalogue could not be loaded.",
    "b2b.no_products_match": "No products match your search.",
    "b2b.retry": "Try again",
    "b2b.order_status.soumise": "Submitted",
    "b2b.order_status.confirmee": "Confirmed",
    "b2b.order_status.facturee": "Invoiced",
    "b2b.order_status.expediee": "Shipped",
    "b2b.order_status.annulee": "Cancelled",
    "b2b.quote_status.nouveau": "New",
    "b2b.quote_status.en_cours": "In progress",
    "b2b.quote_status.repondu": "Replied",
    "b2b.quote_status.cloture": "Closed",
    "b2b.prices_eur_note": "Prices in euros · VAT not applied",
    "cart.no_vat": "VAT not applied",
    "cart.continue_shopping": "Continue shopping",
    "b2b.col_product": "Product",
    "b2b.col_retail": "Retail",
    "b2b.col_wholesale": "Trade price",
    "b2b.col_min": "Min qty",
    "b2b.col_qty": "Quantity",
    "b2b.col_date": "Date",
    "b2b.col_status": "Status",
    "b2b.stock": "Stock:",
    "b2b.cart_title": "Your order",
    "b2b.cart_empty": "Add quantities from the catalogue.",
    "b2b.remove": "Remove",
    "b2b.min_warning": "Minimum quantity not reached:",
    "b2b.total_estimate": "Estimated total",
    "b2b.place_order": "Place order",
    "b2b.request_quote": "Request a quote",
    "b2b.invoice_note": "Order on invoice — no online payment. We confirm your order within 48 h.",
    "b2b.confirm_order_title": "Confirm order",
    "b2b.confirm_quote_title": "Request a quote",
    "b2b.items_label": "item(s)",
    "b2b.order_note_placeholder": "Note for our team (delivery, timing...)",
    "b2b.quote_note_placeholder": "Your message (desired quantities, customisation...)",
    "b2b.confirm_order_button": "Confirm order",
    "b2b.confirm_quote_button": "Send quote request",
    "b2b.order_submitted": "Order submitted",
    "b2b.quote_submitted": "Quote request sent. We will get back to you shortly.",
    "b2b.history_title": "My orders & quotes",
    "b2b.quotes_label": "Quotes",
    "b2b.no_orders": "No orders yet.",
    "b2b.no_quotes": "No quote requests yet.",
    "b2b.estimate_label": "Estimate",
    "ateliers.eyebrow": "Craftsmanship",
    "ateliers.title": "Workshops & artisans",
    "ateliers.empty": "No workshop profiles published yet.",
    "ateliers.empty_cta": "Discover our craftsmanship",

    "home.seo_title": "LEVAMI | Keffiehs, Tatreez and contemporary Levantine fashion",
    "home.seo_description": "LEVAMI is a cultural fashion and textile house rooted in Palestinian, Syrian and Levantine heritage. Keffiehs, dresses, embroidered pieces, shawls and jewellery.",
    "home.hero_eyebrow": "New collection",
    "home.hero_title_line1": "Wear",
    "home.hero_title_line2": "a story",
    "home.hero_subtitle": "Keffiehs, embroidered pieces and contemporary garments connected to Palestinian and Syrian heritage.",
    "home.hero_cta_boutique": "Discover the shop",
    "home.hero_cta_histoire": "Discover our story",
    "home.collections_title": "The collections",
    "home.featured_title": "Chosen pieces",
    "home.intro_eyebrow": "The house",
    "home.intro_title": "From the Levant, for the world",
    "home.intro_p1": "LEVAMI is a clothing and textile brand born between Palestine, Syria and France.",
    "home.intro_p2": "We develop and select keffiehs, embroidered pieces, dresses, shawls and accessories designed to be worn today.",
    "home.founder_title": "A lived story",
    "home.founder_quote": "I wanted to create a brand rooted in a real story, not just an aesthetic.",
    "home.founder_p1": "Iwan is French-Syrian, of Palestinian origin. His family comes from Tiberias, in Palestine. He was born and raised in Syria, close to the Palestinian communities of Damascus and its countryside.",
    "home.founder_p2": "After more than ten years in the humanitarian sector and more than eleven years away from Syria, he returned. He reconnected with relatives, families and workshops whose skills had survived years of war and crisis. This experience gave rise to LEVAMI.",
    "home.founder_cta": "Read our story",
    "home.craft_title": "The gesture behind the piece",
    "home.craft_p1": "For generations, people have embroidered, woven, cut and assembled the textiles of the Levant.",
    "home.craft_p2": "LEVAMI works with relatives, artisans and workshops to give these gestures a place today.",
    "home.craft_cta": "Discover the craftsmanship",
    "home.lookbook_title": "Worn every day",
    "home.lookbook_subtitle": "Pieces worn simply, alone or layered.",
    "home.lookbook_cta": "View the lookbook",
    "home.principles_title": "How we work",
    "home.principle1_title": "Direct relationships",
    "home.principle1_text": "Bonds built with families, relatives and workshops, rather than an anonymous network.",
    "home.principle2_title": "Human-scale series",
    "home.principle2_text": "Collections move forward according to the workshops' capacity and the quality sought.",
    "home.principle3_title": "Product transparency",
    "home.principle3_text": "Each product page indicates LEVAMI's role, the place of production and the materials, whenever this information is available.",
    "home.newsletter_title": "Receive LEVAMI's news",
    "home.newsletter_subtitle": "New collections, stories behind the pieces, events and limited editions.",
    "home.alt_hero": "Group of four people wearing keffiehs and embroidered Levami pieces in a garden.",
    "home.alt_founder": "Portrait of Iwan, founder of LEVAMI, wearing an embroidered piece.",
    "home.alt_craft": "Woman wearing a keffieh and an embroidered Levami creation.",
    "home.alt_lookbook_group": "Group wearing Levami creations in a plant-filled garden.",
    "home.alt_lookbook_solo": "Woman wearing an embroidered white top and a long embroidered black skirt.",

    "contact.seo_title": "Contact | LEVAMI",
    "contact.seo_description": "Contact the LEVAMI team by email, WhatsApp or via our form.",
    "contact.title": "Contact",
    "contact.whatsapp_label": "WhatsApp:",
    "contact.firstname_placeholder": "First name",
    "contact.lastname_placeholder": "Last name",
    "contact.email_placeholder": "Email",
    "contact.order_placeholder": "Order number (optional)",
    "contact.subject_placeholder": "Subject",
    "contact.subject_order": "Order",
    "contact.subject_product": "Product",
    "contact.subject_partnership": "Partnership",
    "contact.subject_press": "Press",
    "contact.subject_event": "Event",
    "contact.subject_other": "Other",
    "contact.message_placeholder": "Your message",
    "contact.consent_prefix": "I agree that my data may be used to process my request, in accordance with the",
    "contact.consent_link": "privacy policy",
    "contact.consent_required_error": "Please accept our privacy policy.",
    "contact.submit": "Send message",
    "contact.submitting": "Sending...",

    "lookbook.seo_title": "LEVAMI Lookbook | Worn every day",
    "lookbook.seo_description": "The LEVAMI lookbook shows the clothes in real life.",
    "lookbook.title": "Worn every day",
    "lookbook.subtitle": "Pieces worn simply, alone or layered. The lookbook shows the cuts, the details and different ways to combine them.",
    "lookbook.filter_all": "All",
    "lookbook.empty": "No image in this category yet.",

    "livraison.seo_title": "Shipping & Returns — LEVAMI",
    "livraison.seo_description": "LEVAMI shipping times, rates and return conditions.",
    "livraison.title": "Shipping & Returns",
    "livraison.free_shipping_banner": "Free shipping from €{{amount}}",
    "livraison.zones_title": "Shipping zones",
    "livraison.zone_france": "France",
    "livraison.zone_eu": "European Union",
    "livraison.zone_europe_non_eu": "Europe outside the EU",
    "livraison.zone_international": "International",
    "livraison.returns_title": "Returns",
    "livraison.returns_text": "Returns possible within {{days}} days, subject to applicable conditions.",
    "livraison.return_address_todo": "The return address is not listed yet. Contact us for return instructions before sending an item back.",
    "livraison.return_contact_link": "Contact us",

    "notfound.seo_title": "Page not found — LEVAMI",
    "notfound.seo_description": "This page does not exist.",
    "notfound.title": "This page does not exist",
    "notfound.text": "The page you are looking for may have been moved or no longer exists.",
    "notfound.cta": "Back to home",

    "checkout_cancel.seo_title": "Payment cancelled — LEVAMI",
    "checkout_cancel.seo_description": "Your payment was cancelled.",
    "checkout_cancel.title": "Payment cancelled",
    "checkout_cancel.text": "Your payment was not completed. Your cart has been saved, you can try again at any time.",
    "checkout_cancel.cta": "Back to cart",

    "journal_detail.not_found": "Article not found",
    "journal_detail.back": "Back to stories",

    "atelier_detail.not_found": "Profile not found",
    "atelier_detail.back": "Back to workshops",
    "atelier_detail.craft_fallback": "Craftsmanship",

    "cookie_consent.title": "Your privacy preferences",
    "cookie_consent.text": "We use essential cookies for the site to function. With your consent, we may also use analytics and marketing cookies. See our",
    "cookie_consent.policy_link": "cookie policy",
    "cookie_consent.essential": "Essential cookies",
    "cookie_consent.analytics": "Analytics",
    "cookie_consent.marketing": "Marketing",
    "cookie_consent.accept_all": "Accept all",
    "cookie_consent.reject_all": "Reject all",
    "cookie_consent.customize": "Customize",
    "cookie_consent.save_preferences": "Save my preferences",

    "newsletter.consent_error": "Please agree to receive our news to subscribe.",
    "newsletter.email_placeholder": "Your email address",
    "newsletter.submit": "Subscribe",
    "newsletter.submitting": "Subscribing...",
    "newsletter.consent_prefix": "I agree to receive LEVAMI's news and I have read the",
    "newsletter.consent_link": "privacy policy",

    "checkout_success.seo_title": "Order confirmed — LEVAMI",
    "checkout_success.seo_description": "Your LEVAMI order has been confirmed.",
    "checkout_success.verifying": "Verifying your payment...",
    "checkout_success.thank_you": "Thank you for your order",
    "checkout_success.payment_confirmed": "Your payment of {{amount}} has been confirmed.",
    "checkout_success.order_number": "Order number:",
    "checkout_success.email_note": "A confirmation email will be sent to you (if an email provider is configured).",
    "checkout_success.continue_shopping": "Continue shopping",
    "checkout_success.pending_title": "Payment being processed",
    "checkout_success.pending_text": "We are still verifying your payment. You will receive a confirmation email once it is validated.",
    "checkout_success.back_home": "Back to home",
    "checkout_success.error_title": "Unable to confirm payment",
    "checkout_success.error_text": "The payment session has expired or an error occurred. Please try again.",
    "checkout_success.back_cart": "Back to cart",
  },

  de: {
    "nav.accueil": "Startseite",
    "nav.espace_pro": "Händlerportal",
    "nav.boutique": "Shop",
    "nav.voir_toute_boutique": "Gesamten Shop ansehen",
    "nav.histoire": "Unsere Geschichte",
    "nav.artisanat": "Handwerkskunst",
    "nav.lookbook": "Lookbook",
    "nav.journal": "Stories",
    "nav.ateliers": "Werkstätten",
    "nav.partenariats": "Kooperationen",
    "nav.contact": "Kontakt",
    "nav.search_aria": "Suchen",
    "nav.search_title": "Produkt suchen",
    "nav.search_label": "Produkt suchen",
    "nav.search_placeholder": "Keffieh, Kleid, Tatreez...",
    "nav.search_button": "Suchen",
    "nav.cart_aria": "Warenkorb öffnen",
    "nav.menu_aria": "Menü",
    "nav.menu_title": "Navigationsmenü",
    "nav.language": "Sprache",
    "nav.currency": "Währung",

    "shop.nouveautes": "Neuheiten",
    "shop.keffiehs": "Keffiehs",
    "shop.robes_abayas": "Kleider & Abayas",
    "shop.pieces_brodees": "Bestickte Stücke",
    "shop.chales_ponchos": "Schals & Ponchos",
    "shop.sacs_accessoires": "Taschen & Accessoires",
    "shop.bijoux": "Schmuck",
    "shop.all": "Gesamter Shop",
    "shop.color": "Farbe",
    "shop.size": "Größe",
    "shop.on_sale": "Im Angebot",
    "shop.is_new": "Neuheiten",
    "shop.show_more": "Mehr anzeigen",
    "shop.show_less": "Weniger anzeigen",
    "shop.clear_filters": "Filter zurücksetzen",
    "shop.sort_placeholder": "Sortieren nach",
    "shop.sort_nouveautes": "Neuheiten",
    "shop.sort_prix_croissant": "Preis aufsteigend",
    "shop.sort_prix_decroissant": "Preis absteigend",
    "shop.sort_mis_en_avant": "Empfohlen",
    "shop.filters": "Filter",
    "shop.filters_title": "Filter",
    "shop.search_placeholder": "Suchen...",
    "shop.intro": "Stücke zum Tragen, Geschichten zum Weitergeben. Entdecken Sie die Farben und das Handwerk der Levante.",
    "shop.categories": "Kollektionen entdecken",
    "shop.show_results": "Stücke ansehen",
    "shop.load_error": "Der Shop konnte nicht geladen werden. Bitte versuchen Sie es erneut.",
    "product.load_error": "Dieses Stück konnte nicht geladen werden.",
    "product.choose_size": "Bitte Größe wählen",
    "product.zoom_image": "Foto vergrößern",
    "product.shipping_summary": "Versandkosten, Lieferzeiten und Rückgabebedingungen finden Sie unter",
    "trust.returns_policy": "Rückgabebedingungen",
    "trust.returns_days": "Rückgabe innerhalb von {{days}} Tagen",
    "product.toggle_zoom": "Zoom umschalten",
    "common.page_load_error": "Diese Seite konnte nicht geladen werden. Bitte versuchen Sie es erneut.",
    "faq.search": "Fragen durchsuchen…",
    "faq.no_answer": "Keine Antwort gefunden? Wir helfen Ihnen gerne.",
    "contact.sent": "Ihre Nachricht wurde empfangen. Vielen Dank für Ihre Kontaktaufnahme.",
    "shop.no_color": "Keine Farbe verfügbar.",
    "shop.no_size": "Keine Größe verfügbar.",
    "shop.empty_title": "Kein Stück entspricht Ihrer Suche",
    "shop.empty_text": "Passen Sie Ihre Filter an oder entdecken Sie den gesamten Shop.",
    "shop.results_for": "Ergebnisse für „{{query}}“",
    "shop.piece_singular": "Stück",
    "shop.piece_plural": "Stück",
    "shop.pagination": "Shop-Seitennavigation",
    "shop.previous_page": "Zurück",
    "shop.next_page": "Weiter",
    "shop.page_of": "Seite {{page}} von {{pages}}",

    "footer.boutique": "Shop",
    "footer.decouvrir": "Entdecken",
    "footer.aide": "Hilfe",
    "footer.livraison_retours": "Versand & Rücksendungen",
    "footer.faq": "FAQ",
    "footer.cgv": "AGB",
    "footer.confidentialite": "Datenschutz",
    "footer.cookies": "Cookies",
    "footer.mentions_legales": "Impressum",
    "footer.tagline": "Aus der Levante, für die Welt",
    "footer.description": "Kleidung, Textilien und Accessoires, verwurzelt im palästinensischen und syrischen Erbe.",
    "footer.newsletter_heading": "Treten Sie der Levami-Welt bei",
    "footer.rights": "Alle Rechte vorbehalten.",

    "cart.title": "Ihr Warenkorb",
    "cart.empty": "Ihr Warenkorb ist leer.",
    "cart.discover": "Shop entdecken",
    "cart.remaining": "Nur noch {{amount}} bis zum kostenlosen Versand.",
    "cart.free_shipping_included": "Kostenloser Versand inklusive",
    "cart.subtotal": "Zwischensumme",
    "cart.discount": "Rabatt",
    "cart.shipping": "Versand",
    "cart.free": "Kostenlos",
    "cart.total": "Gesamt",
    "cart.coupon_placeholder": "Rabattcode",
    "cart.apply": "Anwenden",
    "cart.view_and_pay": "Warenkorb ansehen & bezahlen",
    "cart.remove_item": "Artikel entfernen",
    "cart.applied_code": "Code {{code}} angewendet.",
    "cart.page_title": "Ihr Warenkorb",
    "cart.page_empty_title": "Ihr Warenkorb ist leer",
    "cart.coordinates": "Ihre Angaben",
    "cart.full_name": "Vollständiger Name",
    "cart.email": "E-Mail",
    "cart.phone": "Telefon",
    "cart.shipping_address": "Lieferadresse",
    "cart.address": "Adresse",
    "cart.address_complement": "Zusatz (optional)",
    "cart.postal_code": "Postleitzahl",
    "cart.city": "Stadt",
    "cart.country": "Land",
    "cart.summary": "Zusammenfassung",
    "cart.pay_button": "Zur Zahlung",
    "cart.redirecting": "Weiterleitung zur Zahlung...",
    "cart.secure_payment": "Sichere Zahlung.",
    "cart.eur_charge_note": "Die Zahlung wird in Euro (EUR) abgewickelt — Ihre Bank übernimmt die Umrechnung.",
    "cart.payment_unavailable": "Die Online-Zahlung ist vorübergehend nicht verfügbar. Bitte kontaktieren Sie uns, um Ihre Bestellung abzuschließen.",
    "cart.missing_contact": "Bitte geben Sie Ihre Kontaktdaten ein.",
    "cart.missing_address": "Bitte geben Sie Ihre Lieferadresse ein.",

    "toast.added_to_cart": "Zum Warenkorb hinzugefügt",
    "toast.view_cart": "Warenkorb ansehen",
    "trust.secure_payment": "Sichere Zahlung",
    "trust.returns": "14 Tage Rückgaberecht",
    "trust.tracked_delivery": "Sendungsverfolgung",
    "trust.craftsmanship": "Palästinensisches & syrisches Handwerk",
    "product.size_guide": "Größentabelle",
    "product.quantity": "Menge",
    "sizeguide.col_size": "Größe",
    "sizeguide.col_chest": "Brustumfang",
    "sizeguide.col_waist": "Taillenumfang",
    "sizeguide.col_hips": "Hüftumfang",
    "sizeguide.col_length": "Länge",
    "sizeguide.unit_note": "Maße in cm, flach gemessen.",
    "product.verified_purchase": "Verifizierter Kauf",
    "product.link_copied": "Link kopiert.",
    "tracking.title": "Meine Bestellung verfolgen",
    "tracking.subtitle": "Geben Sie Ihre E-Mail und Bestellnummer ein, um den Status zu sehen.",
    "tracking.email_label": "E-Mail",
    "tracking.order_label": "Bestellnummer",
    "tracking.submit": "Bestellung verfolgen",
    "tracking.searching": "Suche läuft...",
    "tracking.not_found": "Keine Bestellung mit dieser E-Mail und Nummer gefunden. Bitte überprüfen Sie Ihre Angaben.",
    "tracking.status_label": "Bestellstatus",
    "tracking.number_label": "Sendungsnummer",
    "tracking.carrier_label": "Versanddienstleister",
    "tracking.items_label": "Artikel",
    "tracking.total_label": "Gesamt",
    "tracking.date_label": "Bestellt am",
    "tracking.help": "Eine Frage zu Ihrer Bestellung?",
    "tracking.contact_us": "Kontaktieren Sie uns",
    "status.en_attente": "Ausstehend",
    "status.payee": "Bezahlt",
    "status.en_preparation": "In Vorbereitung",
    "status.expediee": "Versendet",
    "status.livree": "Zugestellt",
    "status.annulee": "Storniert",
    "status.remboursee": "Erstattet",
    "lookbook.shop_the_look": "Den Look shoppen",
    "lookbook.pieces_in_photo": "Die Stücke auf diesem Foto",
    "common.see": "Ansehen",
    "welcome.title": "{{discount}} auf Ihre erste Bestellung",
    "welcome.thanks_title": "Willkommen bei LEVAMI",
    "welcome.text": "Abonnieren Sie unseren Newsletter und erhalten Sie {{discount}} auf Ihre erste Bestellung. Handwerksgeschichten, Neuheiten und Angebote — nie Spam.",
    "welcome.email_placeholder": "Ihre E-Mail-Adresse",
    "welcome.cta": "Meinen {{discount}}-Code erhalten",
    "welcome.no_thanks": "Nein danke, ich fahre ohne Rabatt fort",
    "welcome.consent_note": "Mit der Anmeldung stimmen Sie dem Erhalt unserer E-Mails zu. Abmeldung mit einem Klick.",
    "welcome.code_text": "Danke! Hier ist Ihr Code für den Warenkorb:",
    "welcome.start_shopping": "Jetzt entdecken",
    "welcome.error": "Anmeldung fehlgeschlagen. Bitte versuchen Sie es erneut.",
    "instagram.title": "Folgen Sie dem Atelier im Alltag",

    "product.add_to_cart": "In den Warenkorb",
    "product.unavailable": "Nicht verfügbar",
    "product.out_of_stock": "Ausverkauft",
    "product.in_stock": "Auf Lager",
    "product.low_stock": "Nur noch {{count}} auf Lager",
    "product.color": "Farbe",
    "product.size": "Größe",
    "product.description": "Beschreibung",
    "product.story": "Die Geschichte des Stücks",
    "product.material_origin": "Material & Herkunft",
    "product.care": "Pflege",
    "product.shipping_returns": "Versand & Rücksendungen",
    "product.shipping_returns_text": "Kostenloser Versand ab 50 € Einkauf. Rücksendungen innerhalb von 14 Tagen möglich. Siehe unsere Seite",
    "product.shipping_returns_link": "Versand & Rücksendungen",
    "product.related": "Das könnte Ihnen auch gefallen",
    "product.reviews": "Kundenbewertungen",
    "product.leave_review": "Bewertung abgeben",
    "product.no_reviews": "Noch keine Bewertungen. Seien Sie der Erste, der seine Erfahrung teilt.",
    "product.share": "Teilen:",
    "product.breadcrumb_home": "Startseite",
    "product.breadcrumb_shop": "Shop",
    "product.not_found": "Produkt nicht gefunden",
    "product.back_to_shop": "Zurück zum Shop",
    "product.not_translated": "Diese Produktseite ist noch nicht vollständig übersetzt. Einige Informationen werden auf Französisch angezeigt.",
    "product.review_title_placeholder": "Titel Ihrer Bewertung",
    "product.review_text_placeholder": "Ihre Bewertung",
    "product.review_firstname_placeholder": "Ihr Vorname",
    "product.review_email_placeholder": "Ihre E-Mail",
    "product.review_order_placeholder": "Bestellnummer (optional, für verifizierten Kauf)",
    "product.review_submit": "Bewertung senden",
    "product.review_submitting": "Wird gesendet...",

    "common.loading": "Wird geladen...",
    "common.error": "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.",
    "announcement.default": "Kostenloser Versand ab 50 € · Rücksendung innerhalb von 14 Tagen",
    "faq.title": "Häufig gestellte Fragen",
    "journal.eyebrow": "Stories",
    "journal.title": "Geschichten & Einblicke",
    "journal.empty": "Noch keine Beiträge veröffentlicht.",
    "journal.empty_cta": "Zum Shop",
    "journal.all_categories": "Alle Beiträge",
    "wishlist.title": "Meine Favoriten",
    "wishlist.eyebrow": "Favoriten",
    "wishlist.subtitle": "Ihre Lieblingsstücke, auf diesem Gerät gespeichert.",
    "wishlist.empty": "Ihre Favoritenliste ist noch leer.",
    "wishlist.unavailable": "Die gespeicherten Artikel sind nicht mehr verfügbar.",
    "wishlist.browse": "Zum Shop",
    "wishlist.add_aria": "Zu Favoriten hinzufügen",
    "wishlist.remove_aria": "Aus Favoriten entfernen",
    "wishlist.nav_aria": "Meine Favoriten ansehen",
    "wishlist.choose_options": "Optionen wählen",
    "wishlist.sold_out": "Derzeit ausverkauft — bald wieder verfügbar",
    "b2b.back_to_shop": "Zurück zum Shop",
    "b2b.portal_title": "Händlerportal",
    "b2b.portal_subtitle": "Großhandelspreise, Sammelbestellungen und Angebote für Wiederverkäufer.",
    "b2b.login_tab": "Anmelden",
    "b2b.register_tab": "Zugang anfragen",
    "b2b.qty_tiers_title": "Mengenrabatte",
    "b2b.qty_tier_line": "Ab {{qty}} Stück: zusätzlich -{{percent}}%",
    "b2b.subtotal_label": "Zwischensumme",
    "b2b.qty_discount_label": "Mengenrabatt (-{{percent}}%)",
    "b2b.qty_tier_hint": "Noch {{missing}} Stück bis zu zusätzlichen -{{percent}}%.",
    "b2b.forgot_link": "Passwort vergessen?",
    "b2b.forgot_title": "Passwort vergessen",
    "b2b.forgot_intro": "Geben Sie die E-Mail-Adresse Ihres Händlerkontos an: Ein Link zum Zurücksetzen (60 Minuten gültig) wird Ihnen zugesandt.",
    "b2b.forgot_send": "Link senden",
    "b2b.forgot_sent_title": "E-Mail gesendet",
    "b2b.forgot_sent_body": "Falls ein Konto für diese Adresse existiert, wurde soeben eine E-Mail zum Zurücksetzen gesendet. Prüfen Sie auch Ihren Spam-Ordner.",
    "b2b.back_to_login": "Zurück zur Anmeldung",
    "b2b.reset_title": "Neues Passwort",
    "b2b.reset_subtitle": "Wählen Sie ein neues Passwort für Ihr Händlerkonto.",
    "b2b.reset_invalid_link": "Ungültiger oder abgelaufener Link.",
    "b2b.new_password": "Neues Passwort",
    "b2b.confirm_password": "Passwort bestätigen",
    "b2b.reset_submit": "Passwort zurücksetzen",
    "b2b.reset_success": "Passwort zurückgesetzt — bitte anmelden.",
    "b2b.passwords_mismatch": "Die beiden Passwörter stimmen nicht überein.",
    "b2b.password": "Passwort",
    "b2b.password_hint": "Mind. 8 Zeichen, Buchstaben + Ziffern",
    "b2b.login_button": "Anmelden",
    "b2b.company": "Firma / Boutique",
    "b2b.contact_name": "Ansprechpartner",
    "b2b.phone": "Telefon",
    "b2b.register_message": "Beschreiben Sie Ihr Geschäft (optional)",
    "b2b.register_button": "Anfrage senden",
    "b2b.register_note": "Unser Team prüft Ihre Anfrage. Sie erhalten eine E-Mail, sobald Ihr Zugang aktiviert ist.",
    "b2b.register_success_title": "Anfrage gesendet!",
    "b2b.register_success_body": "Unser Team prüft Ihre Anfrage. Sie erhalten eine E-Mail, sobald Ihr Zugang aktiviert ist.",
    "b2b.nav_catalog": "Katalog",
    "b2b.nav_boutique": "Boutique",
    "b2b.nav_orders": "Meine Bestellungen",
    "b2b.professional_price": "Händlerpreis",
    "b2b.price_unavailable": "Händlerpreis nicht verfügbar",
    "b2b.product_minimum": "Mindestbestellmenge: {{quantity}} Stück",
    "b2b.add_to_order": "Zur Bestellung hinzufügen",
    "b2b.added_to_order_cart": "Zur Händlerbestellung hinzugefügt",
    "b2b.view_order_cart": "Bestellung ansehen",
    "b2b.local_demo_title": "Lokale B2B-Demo",
    "b2b.local_demo_email": "E-Mail",
    "b2b.local_demo_password": "Passwort",
    "b2b.local_demo_safety": "Fiktives Konto und Produkte. Echte Bestellungen, Angebote und Zahlungen sind deaktiviert.",
    "b2b.local_demo_products": "Lokale Demo: Die angezeigten Produkte und Preise sind fiktiv.",
    "b2b.logout": "Abmelden",
    "b2b.footer_note": "Nur für Händler — Zahlung auf Rechnung",
    "b2b.catalog_title": "Großhandelskatalog",
    "b2b.catalog_subtitle": "Ihre Händlerpreise",
    "b2b.search_products": "Produkt oder SKU suchen",
    "b2b.product_count": "{{count}} Produkt(e)",
    "b2b.view_catalog": "Vollständiger Katalog",
    "b2b.view_order": "Meine Bestellung",
    "b2b.add_more_products": "Weitere Produkte hinzufügen",
    "b2b.price_retail_unit": "Einzelhandelspreis / Stück",
    "b2b.price_pro_unit": "Händlerpreis / Stück",
    "b2b.price_pro_total": "Händlersumme",
    "b2b.retail_total": "Summe zum Einzelhandelspreis",
    "b2b.increase_quantity": "Menge erhöhen für",
    "b2b.decrease_quantity": "Menge verringern für",
    "b2b.catalog_error": "Der Katalog konnte nicht geladen werden.",
    "b2b.no_products_match": "Keine Produkte entsprechen Ihrer Suche.",
    "b2b.retry": "Erneut versuchen",
    "b2b.order_status.soumise": "Eingereicht",
    "b2b.order_status.confirmee": "Bestätigt",
    "b2b.order_status.facturee": "In Rechnung gestellt",
    "b2b.order_status.expediee": "Versandt",
    "b2b.order_status.annulee": "Storniert",
    "b2b.quote_status.nouveau": "Neu",
    "b2b.quote_status.en_cours": "In Bearbeitung",
    "b2b.quote_status.repondu": "Beantwortet",
    "b2b.quote_status.cloture": "Geschlossen",
    "b2b.prices_eur_note": "Preise in Euro · Keine Mehrwertsteuer berechnet",
    "cart.no_vat": "Keine Mehrwertsteuer berechnet",
    "cart.continue_shopping": "Weiter einkaufen",
    "b2b.col_product": "Produkt",
    "b2b.col_retail": "UVP",
    "b2b.col_wholesale": "Händlerpreis",
    "b2b.col_min": "Mindestmenge",
    "b2b.col_qty": "Menge",
    "b2b.col_date": "Datum",
    "b2b.col_status": "Status",
    "b2b.stock": "Bestand:",
    "b2b.cart_title": "Ihre Bestellung",
    "b2b.cart_empty": "Fügen Sie Mengen aus dem Katalog hinzu.",
    "b2b.remove": "Entfernen",
    "b2b.min_warning": "Mindestmenge nicht erreicht:",
    "b2b.total_estimate": "Geschätzte Summe",
    "b2b.place_order": "Bestellung aufgeben",
    "b2b.request_quote": "Angebot anfragen",
    "b2b.invoice_note": "Bestellung auf Rechnung — keine Online-Zahlung. Bestätigung innerhalb von 48 Std.",
    "b2b.confirm_order_title": "Bestellung bestätigen",
    "b2b.confirm_quote_title": "Angebot anfragen",
    "b2b.items_label": "Artikel",
    "b2b.order_note_placeholder": "Hinweis an unser Team (Lieferung, Fristen...)",
    "b2b.quote_note_placeholder": "Ihre Nachricht (gewünschte Mengen, Personalisierung...)",
    "b2b.confirm_order_button": "Bestellung bestätigen",
    "b2b.confirm_quote_button": "Angebotsanfrage senden",
    "b2b.order_submitted": "Bestellung gesendet",
    "b2b.quote_submitted": "Angebotsanfrage gesendet. Wir melden uns in Kürze.",
    "b2b.history_title": "Meine Bestellungen & Angebote",
    "b2b.quotes_label": "Angebote",
    "b2b.no_orders": "Noch keine Bestellungen.",
    "b2b.no_quotes": "Noch keine Angebotsanfragen.",
    "b2b.estimate_label": "Schätzung",
    "ateliers.eyebrow": "Handwerkskunst",
    "ateliers.title": "Werkstätten & Kunsthandwerker",
    "ateliers.empty": "Noch keine Werkstattprofile veröffentlicht.",
    "ateliers.empty_cta": "Handwerkskunst entdecken",

    "home.seo_title": "LEVAMI | Keffiehs, Tatreez und zeitgenössische Levante-Mode",
    "home.seo_description": "LEVAMI ist ein Mode- und Textilhaus, verwurzelt im palästinensischen, syrischen und levantinischen Erbe. Keffiehs, Kleider, bestickte Stücke, Schals und Schmuck.",
    "home.hero_eyebrow": "Neue Kollektion",
    "home.hero_title_line1": "Tragen Sie",
    "home.hero_title_line2": "eine Geschichte",
    "home.hero_subtitle": "Keffiehs, bestickte Stücke und zeitgenössische Kleidung, verbunden mit palästinensischem und syrischem Erbe.",
    "home.hero_cta_boutique": "Shop entdecken",
    "home.hero_cta_histoire": "Unsere Geschichte entdecken",
    "home.collections_title": "Die Kollektionen",
    "home.featured_title": "Ausgewählte Stücke",
    "home.intro_eyebrow": "Das Haus",
    "home.intro_title": "Aus der Levante, für die Welt",
    "home.intro_p1": "LEVAMI ist eine Kleidungs- und Textilmarke, entstanden zwischen Palästina, Syrien und Frankreich.",
    "home.intro_p2": "Wir entwickeln und wählen Keffiehs, bestickte Stücke, Kleider, Schals und Accessoires aus, die für das Tragen im Alltag gedacht sind.",
    "home.founder_title": "Eine gelebte Geschichte",
    "home.founder_quote": "Ich wollte eine Marke schaffen, die in einer echten Geschichte verwurzelt ist, nicht nur in einer Ästhetik.",
    "home.founder_p1": "Iwan ist französisch-syrisch und palästinensischer Abstammung. Seine Familie stammt aus Tiberias in Palästina. Er wurde in Syrien geboren und wuchs dort auf, im Kontakt mit den palästinensischen Gemeinschaften von Damaskus und seinem Umland.",
    "home.founder_p2": "Nach mehr als zehn Jahren im humanitären Bereich und mehr als elf Jahren fern von Syrien kehrte er zurück. Er traf Angehörige, Familien und Werkstätten wieder, deren Fertigkeiten die Kriegs- und Krisenjahre überstanden hatten. Aus dieser Erfahrung entstand LEVAMI.",
    "home.founder_cta": "Unsere Geschichte lesen",
    "home.craft_title": "Die Geste hinter dem Stück",
    "home.craft_p1": "Seit Generationen sticken, weben, schneiden und fertigen Menschen die Textilien der Levante.",
    "home.craft_p2": "LEVAMI arbeitet mit Angehörigen, Kunsthandwerkern und Werkstätten zusammen, um diesen Gesten einen heutigen Platz zu geben.",
    "home.craft_cta": "Handwerkskunst entdecken",
    "home.lookbook_title": "Im Alltag getragen",
    "home.lookbook_subtitle": "Stücke, einfach getragen, allein oder kombiniert.",
    "home.lookbook_cta": "Lookbook ansehen",
    "home.principles_title": "Wie wir arbeiten",
    "home.principle1_title": "Direkte Beziehungen",
    "home.principle1_text": "Verbindungen, die mit Familien, Angehörigen und Werkstätten aufgebaut wurden, statt einem anonymen Netzwerk.",
    "home.principle2_title": "Kollektionen in menschlichem Maßstab",
    "home.principle2_text": "Kollektionen entwickeln sich entsprechend den Kapazitäten der Werkstätten und der angestrebten Qualität.",
    "home.principle3_title": "Produkttransparenz",
    "home.principle3_text": "Jede Produktseite gibt die Rolle von LEVAMI, den Produktionsort und die Materialien an, sofern diese Informationen verfügbar sind.",
    "home.newsletter_title": "Neuigkeiten von LEVAMI erhalten",
    "home.newsletter_subtitle": "Neue Kollektionen, Geschichten hinter den Stücken, Veranstaltungen und limitierte Editionen.",
    "home.alt_hero": "Gruppe von vier Personen mit Keffiehs und bestickten Levami-Stücken in einem Garten.",
    "home.alt_founder": "Porträt von Iwan, Gründer von LEVAMI, mit einem bestickten Stück.",
    "home.alt_craft": "Frau mit einem Keffieh und einer bestickten Levami-Kreation.",
    "home.alt_lookbook_group": "Gruppe mit Levami-Kreationen in einem grünen Garten.",
    "home.alt_lookbook_solo": "Frau mit einem bestickten weißen Oberteil und einem langen bestickten schwarzen Rock.",

    "contact.seo_title": "Kontakt | LEVAMI",
    "contact.seo_description": "Kontaktieren Sie das LEVAMI-Team per E-Mail, WhatsApp oder über unser Formular.",
    "contact.title": "Kontakt",
    "contact.whatsapp_label": "WhatsApp:",
    "contact.firstname_placeholder": "Vorname",
    "contact.lastname_placeholder": "Nachname",
    "contact.email_placeholder": "E-Mail",
    "contact.order_placeholder": "Bestellnummer (optional)",
    "contact.subject_placeholder": "Betreff",
    "contact.subject_order": "Bestellung",
    "contact.subject_product": "Produkt",
    "contact.subject_partnership": "Partnerschaft",
    "contact.subject_press": "Presse",
    "contact.subject_event": "Veranstaltung",
    "contact.subject_other": "Sonstiges",
    "contact.message_placeholder": "Ihre Nachricht",
    "contact.consent_prefix": "Ich stimme zu, dass meine Daten zur Bearbeitung meiner Anfrage verwendet werden, gemäß der",
    "contact.consent_link": "Datenschutzerklärung",
    "contact.consent_required_error": "Bitte akzeptieren Sie unsere Datenschutzerklärung.",
    "contact.submit": "Nachricht senden",
    "contact.submitting": "Wird gesendet...",

    "lookbook.seo_title": "LEVAMI Lookbook | Im Alltag getragen",
    "lookbook.seo_description": "Das LEVAMI-Lookbook zeigt die Kleidung im echten Leben.",
    "lookbook.title": "Im Alltag getragen",
    "lookbook.subtitle": "Stücke, einfach getragen, allein oder kombiniert. Das Lookbook zeigt Schnitte, Details und verschiedene Kombinationsmöglichkeiten.",
    "lookbook.filter_all": "Alle",
    "lookbook.empty": "Noch kein Bild in dieser Kategorie.",

    "livraison.seo_title": "Versand & Rücksendungen — LEVAMI",
    "livraison.seo_description": "Lieferzeiten, Versandkosten und Rückgabebedingungen von LEVAMI.",
    "livraison.title": "Versand & Rücksendungen",
    "livraison.free_shipping_banner": "Kostenloser Versand ab {{amount}} €",
    "livraison.zones_title": "Versandzonen",
    "livraison.zone_france": "Frankreich",
    "livraison.zone_eu": "Europäische Union",
    "livraison.zone_europe_non_eu": "Europa außerhalb der EU",
    "livraison.zone_international": "International",
    "livraison.returns_title": "Rücksendungen",
    "livraison.returns_text": "Rücksendungen innerhalb von {{days}} Tagen möglich, gemäß den geltenden Bedingungen.",
    "livraison.return_address_todo": "Die Rücksendeadresse ist noch nicht angegeben. Bitte kontaktieren Sie uns vor der Rücksendung eines Artikels für die Rücksendehinweise.",
    "livraison.return_contact_link": "Kontakt",

    "notfound.seo_title": "Seite nicht gefunden — LEVAMI",
    "notfound.seo_description": "Diese Seite existiert nicht.",
    "notfound.title": "Diese Seite existiert nicht",
    "notfound.text": "Die gesuchte Seite wurde möglicherweise verschoben oder existiert nicht mehr.",
    "notfound.cta": "Zurück zur Startseite",

    "checkout_cancel.seo_title": "Zahlung abgebrochen — LEVAMI",
    "checkout_cancel.seo_description": "Ihre Zahlung wurde abgebrochen.",
    "checkout_cancel.title": "Zahlung abgebrochen",
    "checkout_cancel.text": "Ihre Zahlung wurde nicht abgeschlossen. Ihr Warenkorb bleibt erhalten, Sie können es jederzeit erneut versuchen.",
    "checkout_cancel.cta": "Zurück zum Warenkorb",

    "journal_detail.not_found": "Artikel nicht gefunden",
    "journal_detail.back": "Zurück zu Stories",

    "atelier_detail.not_found": "Profil nicht gefunden",
    "atelier_detail.back": "Zurück zu Werkstätten",
    "atelier_detail.craft_fallback": "Handwerkskunst",

    "cookie_consent.title": "Ihre Datenschutzeinstellungen",
    "cookie_consent.text": "Wir verwenden essenzielle Cookies für den Betrieb der Website. Mit Ihrer Zustimmung können wir auch Analyse- und Marketing-Cookies verwenden. Siehe unsere",
    "cookie_consent.policy_link": "Cookie-Richtlinie",
    "cookie_consent.essential": "Essenzielle Cookies",
    "cookie_consent.analytics": "Analyse (Analytics)",
    "cookie_consent.marketing": "Marketing",
    "cookie_consent.accept_all": "Alle akzeptieren",
    "cookie_consent.reject_all": "Alle ablehnen",
    "cookie_consent.customize": "Anpassen",
    "cookie_consent.save_preferences": "Meine Einstellungen speichern",

    "newsletter.consent_error": "Bitte stimmen Sie zu, unsere Neuigkeiten zu erhalten, um sich anzumelden.",
    "newsletter.email_placeholder": "Ihre E-Mail-Adresse",
    "newsletter.submit": "Anmelden",
    "newsletter.submitting": "Anmeldung...",
    "newsletter.consent_prefix": "Ich stimme zu, die Neuigkeiten von LEVAMI zu erhalten, und habe die",
    "newsletter.consent_link": "Datenschutzerklärung",

    "checkout_success.seo_title": "Bestellung bestätigt — LEVAMI",
    "checkout_success.seo_description": "Ihre LEVAMI-Bestellung wurde bestätigt.",
    "checkout_success.verifying": "Zahlung wird überprüft...",
    "checkout_success.thank_you": "Vielen Dank für Ihre Bestellung",
    "checkout_success.payment_confirmed": "Ihre Zahlung von {{amount}} wurde bestätigt.",
    "checkout_success.order_number": "Bestellnummer:",
    "checkout_success.email_note": "Eine Bestätigungs-E-Mail wird Ihnen zugesendet (falls ein E-Mail-Anbieter konfiguriert ist).",
    "checkout_success.continue_shopping": "Weiter einkaufen",
    "checkout_success.pending_title": "Zahlung wird verarbeitet",
    "checkout_success.pending_text": "Wir überprüfen Ihre Zahlung noch. Sie erhalten eine Bestätigungs-E-Mail, sobald sie validiert wurde.",
    "checkout_success.back_home": "Zurück zur Startseite",
    "checkout_success.error_title": "Zahlung konnte nicht bestätigt werden",
    "checkout_success.error_text": "Die Zahlungssitzung ist abgelaufen oder ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.",
    "checkout_success.back_cart": "Zurück zum Warenkorb",
  },
};
